import React from "react";
import styled, { keyframes } from "styled-components";

// Configuration values from the customize panel
const BEAM_WIDTH = 3;
const BEAM_HEIGHT = 30;
const BEAM_COUNT = 20;
const SPEED = 2;
const NOISE_INTENSITY = 1.75;
const NOISE_SCALE = 0.2;
const ROTATION = 30;
const COLOR = "#4A90E2"; // Medium blue color

const beamMove = keyframes`
  0% {
    transform: translateX(-100%) translateY(-100%) rotate(${ROTATION}deg);
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
  100% {
    transform: translateX(100%) translateY(100%) rotate(${ROTATION}deg);
    opacity: 0;
  }
`;

const BeamsContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: -1;
  background-color: #050216;
  overflow: hidden;
  pointer-events: none;
`;

const Beam = styled.div`
  position: absolute;
  width: ${BEAM_WIDTH}px;
  height: ${BEAM_HEIGHT * 4}vh;
  background: linear-gradient(
    to bottom,
    transparent 0%,
    rgba(74, 144, 226, 0.4) 20%,
    rgba(74, 144, 226, 0.9) 50%,
    rgba(74, 144, 226, 0.4) 80%,
    transparent 100%
  );
  animation: ${beamMove} ${(props) => (props.duration || 8) / SPEED}s linear infinite;
  animation-delay: ${(props) => props.delay || 0}s;
  left: ${(props) => props.left || 0}%;
  transform-origin: center;
  filter: blur(${NOISE_INTENSITY}px);
  top: -${BEAM_HEIGHT * 2}vh;
  opacity: 0.9;
`;

const BeamsBackground = () => {
  // Generate beams based on BEAM_COUNT
  const beams = Array.from({ length: BEAM_COUNT }, (_, index) => {
    const left = (100 / (BEAM_COUNT + 1)) * (index + 1);
    const delay = (index * 0.3) % 3;
    const baseDuration = 8;
    const duration = baseDuration + (index % 5);
    return { left, delay, duration };
  });

  return (
    <BeamsContainer>
      {beams.map((beam, index) => (
        <Beam
          key={index}
          left={beam.left}
          delay={beam.delay}
          duration={beam.duration}
        />
      ))}
    </BeamsContainer>
  );
};

export default BeamsBackground;

